<template>
<div class="article_wrap">
    <div class="article_top_wrap">
        <div class="article_top">
            <div class="article_top_center">
                <h1 class="article_top_h1">{{ $t("faq_article.title") }}</h1>
                <div class="article_top_search">
                    <input v-model="searchQuery" type="text" class="faqsearch outline-none" :placeholder="$t('faq_article.search_placeholder')">
                    <div class="faqsearch_btn" @click="searchFaq">
                        <img src="@/assets/index/img/faq/icon_search.png" alt="search">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="article_main_wrap">
        <div class="article_main">
            <div class="article_main_left">
                <div class="article_path">
                    <a href="/" target="_blank">{{ $t("faq_article.breadcrumb.home") }}</a>
                    /
                    <a href="/faq/" target="_blank">{{ $t("faq_article.breadcrumb.faq") }}</a>
                    /
                    <span class="current">{{ article.title }}</span>
                </div>
                <h1 class="article_main_title">{{ article.title }}</h1>
                
                <el-skeleton :rows="6" animated :loading="loading">
                    <div class="article_main_text" v-html="article.content"></div>
                </el-skeleton>
                <div class="evaluate">
                    <span class="evaluate_text">{{ $t("faq_article.evaluate_instruction") }}</span>
                    <el-rate v-model="evaluate_star" :colors="rate_colors" @change="changeEvaluateStar" class="mt-[15px]"></el-rate>
                </div>
                <div class="expand">
                    <ul class="expand_list questions">
                        <li class="expand_item expand_item_title">
                            <span>{{ $t("faq_article.related_questions") }}</span>
                        </li>
                        <li v-for="(article, index) in related_articles" :key="index" class="expand_item expand_item_link">
                          <a target="_blank" class="expand_item_txt" :href="`/faq/${article.subtitle}.html`">{{ article.title }}</a>
                       </li>
                    </ul>
                    <ul class="expand_list proxies">
                        <li class="expand_item expand_item_title">
                            <span>{{ $t("faq_article.buy_proxies") }}</span>
                        </li>
                        <li class="expand_item">
                            <a href="/staticisp/" target="_blank">{{ $t("faq_article.static_ips") }}</a>
                        </li>
                        <li class="expand_item">
                            <a href="/residential/" target="_blank">{{ $t("faq_article.residential") }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="article_main_right">
                <a class="article_main_right_img" href="/staticisp/">
                    <img src="@/assets/index/img/faq/staticisp.webp" alt="">
                </a>
                <ul class="article_main_class">
                    <li class="article_main_class_title">{{ $t("faq_article.popular_questions") }}</li>
                    <li class="article_main_class_text">
                       <a v-for="(article, index) in popular_articles" :key="article.id" 
                          :href="`/faq/${article.subtitle}.html`" class="article_main_class_texta">
                            <img src="@/assets/index/img/faq/arrow.png" alt="" class="nhover">
                            <img src="@/assets/index/img/faq/arrowa.png" alt="" class="hover">
                            <p>{{ article.title }}</p>
                       </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getFaqBySubtitle, getFaqByRand, getPopularFaqs, submitEvaluateStar} from '@/http/api/faq'

export default {
  name: 'faq',
  data(){
    return {
      loading: false,
      article: {},
      related_articles: [],
      popular_articles: [],
      
      searchQuery: '',

      evaluate_star: 0,
      rate_colors: ['#99A9BF', '#F7BA2A', '#FF9900']
    }
  },
  mounted() {
    let subtitle = this.$route.params?.subtitle;
    this.getArticleBySubtitle(subtitle);
    this.fetchRelatedArticles();
    this.fetchPopularArticles();
  },
  methods:{
    getArticleBySubtitle(subtitle) {
      this.loading = true
      getFaqBySubtitle({subtitle}).then(response => {
        this.article = response.data;
      }).catch(e => {
        this.$message.error(e.message ?? e.msg ?? this.$t("faq_article.message.load_content_fails"));
      }).finally(() => {
        this.loading = false;
      });
    },

    fetchRelatedArticles() {
      getFaqByRand().then(response => {
        this.related_articles = response.data;
      }).catch(e => {
        this.$message.error(this.$t("faq_article.message.load_related_fails"));
      });
    },

    fetchPopularArticles() {
      getPopularFaqs().then(response => {
        this.popular_articles = response.data;
      }).catch(e => {
        this.$message.error(this.$t("faq_article.message.load_popular_fails"));
      });
    },

    searchFaq() {
      const classId = this.article.category_id;
      const searchQuery = this.searchQuery;
      window.location.href = `/faq/?class=${classId}&search=${searchQuery}`;
    },
    changeEvaluateStar() {
      submitEvaluateStar({
        id: this.article.id,
        star: this.evaluate_star
      }).then(response => {
      }).catch(e => {
        console.log(this.$t("faq_article.message.submit_evaluate_fails"));
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.article_wrap {
    padding-bottom: 100px;
    color: #1c3b3b;
}

.article_wrap .article_top_wrap {
    margin-bottom: 58px
}

.article_wrap .article_top_wrap .article_top {
    padding-top: 133px;
    background-color: #e9f2fa;
    padding-bottom: 72px
}

.article_wrap .article_top_wrap .article_top .article_top_center {
    max-width: 1200px;
    margin: auto
}

.article_wrap .article_top_wrap .article_top .article_top_center .article_top_h1 {
    font-size: 52px;
    font-family: "Poppins-Medium";
    font-weight: bold;
    color: #223265;
    line-height: 70px;
    margin-bottom: 41px
}

.article_wrap .article_top_wrap .article_top .article_top_center .article_top_search {
    max-width: 735px;
    height: 64px;
    background-color: #ffffff;
    box-shadow: 0px 3px 21px 0px rgba(11,31,75,0.1);
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between
}

.article_wrap .article_top_wrap .article_top .article_top_center .article_top_search input {
    width: calc(100% - 32px);
    border: 0px;
    font-size: 18px;
    color: #b7b7b7
}

.article_wrap .article_top_wrap .article_top .article_top_center .article_top_search .faqsearch_btn {
    width: 25px;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer
}

.article_wrap .article_main_wrap .article_main {
    max-width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between
}

.article_wrap .article_main_wrap .article_main .article_main_left {
    width: 760px
}

.article_wrap .article_main_wrap .article_main .article_main_left .article_path {
    height: 25px;
    font-family: "Poppins-Medium";
    line-height: 25px;
    margin-bottom: 10px;
    padding: 5px 0 10px;
    font-weight: 500;
    font-size: 13px;
    color: #263364
}

.article_wrap .article_main_wrap .article_main .article_main_left .article_path a {
    color: #747985;
    cursor: pointer
}

.article_wrap .article_main_wrap .article_main .article_main_left .article_path .current {
    color: #747985;
    cursor: pointer
}

.article_wrap .article_main_wrap .article_main .article_main_left .article_main_title {
    font-size: 30px;
    font-family: "Poppins-Medium";
    font-weight: bold;
    color: #223265;
    line-height: 72px;
    text-align: center
}

.article_wrap .article_main_wrap .article_main .article_main_left .article_main_text {
    min-height: 456px;
    margin-bottom: 30px;
    font-size: 18px;
    font-family: "Poppins-Medium";
    font-weight: 500;
    color: #333333;
    line-height: 36px;
    margin-top: 20px
}

.article_wrap .article_main_wrap .article_main .article_main_left .evaluate {
    width: 100%;
    background-color: #f2f2f2;
    padding: 18px 0 23px;
    margin: 0 auto 100px;
    text-align: center
}

.article_wrap .article_main_wrap .article_main .article_main_left .evaluate .evaluate_text {
    font-size: 16px;
    font-family: 'Poppins-Medium';
    font-weight: 500;
    color: #717171
}

.article_wrap .article_main_wrap .article_main .article_main_left .evaluate #evaluate_star {
    width: 200px;
    height: 32px;
    margin-top: 28px
}

.article_wrap .article_main_wrap .article_main .article_main_left .evaluate #evaluate_star .layui-rate {
    padding: 0
}

.article_wrap .article_main_wrap .article_main .article_main_left .evaluate #evaluate_star .layui-rate li i.layui-icon {
    font-size: 30px
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list {
    width: 100%;
    box-sizing: border-box;
    padding: 26px 20px 49px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list .expand_item {
    box-sizing: border-box;
    display: list-item;
    width: 48%;
    height: 48px;
    list-style-type: disc;
    list-style-position: inside;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list .expand_item:last-of-type {
    margin-bottom: 0px
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list .expand_item.expand_item_title {
    width: 100%;
    list-style: none
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list .expand_item span {
    font-size: 24px;
    font-family: 'Poppins-Medium';
    font-weight: 500;
    color: #223265;
    line-height: 48px
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list .expand_item a {
    font-size: 16px;
    font-family: 'Poppins-Medium';
    font-weight: 500;
    color: #333333;
    cursor: pointer;
    line-height: 48px
}

.article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list .expand_item a:hover {
    text-decoration: underline;
    color: #276DFD
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_right_img {
    display: block;
    height: 302.5px;
    margin-bottom: 30px;
    margin-top: 56px
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_right_img img {
    // width: 363px;
    height: 302.5px
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_title {
    margin-bottom: 0px;
    font-size: 24px;
    font-family: "Poppins-Medium";
    font-weight: 500;
    color: #223265;
    line-height: 72px
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text {
    margin-bottom: 14px
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta {
    display: flex;
    align-items: center
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta img {
    width: 13px;
    height: 10px;
    margin-right: 30px
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta img.hover {
    display: none
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta p {
    display: flex;
    align-items: center;
    width: 320px;
    height: 48px;
    font-size: 16px;
    font-family: "Poppins-Medium";
    font-weight: 500;
    color: #333333
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta:hover .hover {
    display: inline-block
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta:hover .nhover {
    display: none
}

.article_wrap .article_main_wrap .article_main .article_main_right .article_main_class .article_main_class_text .article_main_class_texta:hover p {
    color: #276DFD
}

@media (max-width: 1200px) {
    .article_wrap .article_main_wrap .article_main {
        flex-wrap:wrap
    }

    .article_wrap .article_main_wrap .article_main .article_main_left {
        width: 80%;
        margin: 0 auto
    }

    .article_wrap .article_main_wrap .article_main .article_main_left .article_main_title {
        line-height: 35px
    }

    .article_wrap .article_main_wrap .article_main .article_main_left .evaluate {
        margin-bottom: 20px
    }

    .article_wrap .article_main_wrap .article_main .article_main_left .expand .expand_list {
        padding-bottom: 20px
    }

    .article_wrap .article_main_wrap .article_main .article_main_right {
        margin: 0 auto
    }
}

@media screen and (max-width: 1000px) {
    .article_wrap .article_top_wrap .article_top .article_top_center .article_top_h1 {
        font-size:50px
    }
}

@media screen and (max-width: 700px) {
    .article_wrap .article_top_wrap .article_top .article_top_center .article_top_h1 {
        font-size:40px
    }
}

@media screen and (max-width: 600px) {
    .article_wrap .article_top_wrap .article_top .article_top_center .article_top_h1 {
        font-size:35px
    }
}

@media screen and (max-width: 500px) {
    .article_wrap .article_top_wrap .article_top .article_top_center .article_top_h1 {
        font-size:30px
    }
}
</style>
